const products = {
  credit_expert: 'credit_expert',
  identity: 'identity',
  basic: 'basic',
  breach: 'breach',
  breachPlus: 'breach_plus',
} as const;

export type ProductFamily = (typeof products)[keyof typeof products];

// HardCode PlanCodes as per Recurly so any change in BE should be updated here
export const flexProducts = {
  free: 'free',
  id: 'id',
  idFree: 'id-free',
  idAnnual: 'id-annual',
  idAnnualFree: 'id-annual-free',
  premiumReactivator: 'premium-reactivator',
  premium: 'premium',
  breach: 'breach',
  breachPlus: 'breach-plus',
} as const;

export type FlexProductCode = (typeof flexProducts)[keyof typeof flexProducts];

// In components which handle old & new flows like switch,coolingoff we can use product aliases to correlate old and new products
export const productAliases: Record<string, ProductFamily> = {
  free: products.basic,
  id: products.identity,
  'id-free': products.identity,
  'id-annual': products.identity,
  'id-annual-free': products.identity,
  'premium-reactivator': products.credit_expert,
  premium: products.credit_expert,
  'breach-plus': products.breachPlus,
};

export const flexProductFamilies = {
  credit_expert: 'credit_expert',
  identity: 'identity',
  basic: 'basic',
  breach: 'breach',
  breachPlus: 'breach_plus',
} as const;

const familyName: Record<ProductFamily, string> = {
  credit_expert: 'CreditExpert',
  identity: 'Identity Plus',
  basic: 'Free',
  breach: 'Breach',
  breach_plus: 'Breach Plus',
};

export const getProductFamilyName = (family: string): string => {
  return familyName[family as keyof typeof familyName] || '';
};

export const normalizeProductFamily = (planCode: string): string =>
  planCode ? productAliases[planCode] || planCode : planCode;

// Product movements that are a downsell (moving to a cheaper family) rather than an upgrade
const DOWNSELL_FAMILY_MOVEMENTS: Partial<Record<ProductFamily, ProductFamily[]>> = {
  [products.credit_expert]: [products.identity],
};

export const isDownsellMovement = (currentFamily?: string, targetFamily?: string): boolean =>
  DOWNSELL_FAMILY_MOVEMENTS[currentFamily as ProductFamily]?.includes(targetFamily as ProductFamily) ?? false;

export default products;
